// @ts-nocheck
import React from 'react';

const Empty = ({ icon: Icon, title, sub, actions, className = '' }) => (
  <div className={`mov-empty text-center ${className}`}>
    {Icon && (
      <div className="mov-empty-icon grid place-items-center mx-auto mb-3">
        <Icon size={18} />
      </div>
    )}
    {title && <h4 className="m-0 mb-1 text-[14px] font-semibold">{title}</h4>}
    {sub && <p className="m-0 mb-3.5 text-[13px] text-mov-ink-soft">{sub}</p>}
    {actions && <div className="inline-flex items-center gap-2">{actions}</div>}
  </div>
);

export default Empty;
